<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação para criação da tarefa em lote</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        Criar uma tarefa em lote que afetam muitos itens pode sobrecarregar a capacidade da sua fila de processamento e
        com isso gerar atraso na comunicação com o marketplace, como por exemplo atualização de estoque e preço. Tem
        certeza que deseja criar essa tarefa em lote?
      </div>

      <div class="l-col-12@md">
        <label class="form-checkbox">
          <input type="checkbox" v-model="checked" v-on:click="checked = true">
          <span class="form-checkbox__indicator"></span>
          <span class="form-checkbox__text"> Li e entendi os efeitos de uma tarefa em lote</span>
        </label>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import notifier from '@/notifier'

  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      checked: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        if (!this.checked) {
          notifier.error('Por gentileza marcar que entendeu os efeitos da tarefa em lote.', 'Erro')
          return false
        }

        this.$emit('option', true)
        this.checked = false
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      cancel () {
        this.isVisible = false
        this.checked = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

  <style lang="sass" scoped>
    .form-checkbox
      margin: 10px

</style>



// WEBPACK FOOTER //
// ModalConfirm.vue?23341730